var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMexc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_18981)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5278_18981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6416 26.6417L33.0646 11.7521C31.1916 8.65211 26.586 8.62247 24.7663 11.8944L15.7685 27.3708C14.0911 30.2219 16.1597 33.7664 19.5383 33.7664H37.6109C40.9896 33.7961 43.5324 30.1092 41.6356 26.6417H41.6416Z",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2649 27.8159L28.7314 26.8912C28.2276 26.0258 27.1369 24.1824 27.1369 24.1824L19.8818 11.5571C18.0088 8.76526 13.5395 8.51038 11.6665 12.0609L3.20216 26.6956C1.44173 29.766 3.54002 33.761 7.33355 33.7907H37.5099C32.8747 33.8203 31.3928 31.3901 29.2708 27.8099L29.2649 27.8159Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2654 27.7577L28.7319 26.833C28.2281 25.9676 27.1374 24.1242 27.1374 24.1242L22.443 15.8555L15.7094 27.3665C14.032 30.2175 16.1006 33.7621 19.4793 33.7621H37.4985C32.8337 33.7325 31.3815 31.3615 29.2594 27.7577H29.2654Z",
    fill: "url(#paint0_linear_5278_18981)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5278_18981",
    x1: 13.3207,
    y1: 22.1385,
    x2: 34.191,
    y2: 29.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003087"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_18981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5278_18981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.7194,
    height: 24.3616,
    fill: "white",
    transform: "translate(2.57422 9.42969)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexc);
export default __webpack_public_path__ + "static/media/mexc.843c94191327dad192b922e520f1adcd.svg";
export { ForwardRef as ReactComponent };